var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.visible
      ? _c("div", { staticClass: "mask" }, [
          _c("audio", {
            attrs: {
              src: _vm.src,
              controls: "controls",
              autoplay: "autoplay",
              controlslist: "nodownload",
            },
          }),
          _c("span", { staticClass: "m-l-10 close" }, [
            _c("i", {
              staticClass: "el-icon-circle-close",
              staticStyle: { color: "#fff" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            }),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }